import React from "react";
import { PolicyLayout } from "./Delivery";
import { siteConfig } from "../Datas/productData";
import "../css/returns.scss";

function Returns() {
  return (
    <PolicyLayout
      title="Returns & exchanges"
      intro="Try everything on at home. If the fit is not right, we’ll help you make the next move."
    >
      <section>
        <span>01</span>
        <div>
          <h2>30-day return window</h2>
          <p>Full-price items may be returned or exchanged within 30 days of delivery. Garments must be unworn, unwashed, unaltered and returned with their original tags.</p>
          <p>Domestic full-price orders over ${siteConfig.freeShippingThreshold} include one complimentary return or exchange label.</p>
        </div>
      </section>
      <section>
        <span>02</span>
        <div>
          <h2>Start a return</h2>
          <p>Email <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a> with your order number, the item you are returning and whether you prefer a refund or exchange.</p>
          <p>Please wait for return instructions before mailing the parcel so it can be matched to your order.</p>
        </div>
      </section>
      <section>
        <span>03</span>
        <div>
          <h2>Final sale and altered goods</h2>
          <p>Final-sale items, gift cards and customized or hemmed garments cannot be returned. Any piece showing wear, washing, fragrance, damage or alteration may be sent back to the customer.</p>
        </div>
      </section>
      <section>
        <span>04</span>
        <div>
          <h2>Refund timing</h2>
          <p>Approved refunds are issued to the original payment method within 3–5 business days of inspection. Your bank may require additional time to post the credit.</p>
        </div>
      </section>
    </PolicyLayout>
  );
}

export default Returns;
